import React, { useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
} from "reactstrap";
import restro from "../../../../../assets/orderingSystem/restrologo.png";

const PrintBillModal = ({ isOpen, toggle, billData }) => {
  const printRef = useRef();

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Bill</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            @media print {
              .no-print {
                display: none;
              }
              body {
                padding: 20px;
              }
              img {
                max-width: 60px;
                height: auto;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                padding: 8px;
                border: 1px solid #ddd;
              }
            }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  if (!isOpen || !billData || billData.length === 0) return null;

  const { orderId, tableNo, items } = billData[0];
  const grandTotal = items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Order #{orderId} - Table {tableNo}</ModalHeader>
      <ModalBody>
        <div ref={printRef}>
          <div className="text-center mb-4">
            <h4 className="fw-bold">Ordering System</h4>
            <p className="mb-0">Date: {new Date().toLocaleString()}</p>
            <hr />
          </div>

          <Table bordered responsive>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Image</th>
                <th className="text-end">Qty</th>
                <th className="text-end">Price (Rs)</th>
                <th className="text-end">Total (Rs)</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>
                    <img src={restro} alt={item.title} width="60" />
                  </td>
                  <td className="text-end">{item.quantity}</td>
                  <td className="text-end">{item.price.toFixed(2)}</td>
                  <td className="text-end">{(item.quantity * item.price).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="text-end mt-3">
            <h5 className="fw-bold">Grand Total: Rs. {grandTotal.toFixed(2)}</h5>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="no-print">
        <Button color="secondary" onClick={toggle}>Close</Button>
        <Button color="primary" onClick={handlePrint}>Print</Button>
      </ModalFooter>
    </Modal>
  );
};

export default PrintBillModal;
